<template>
  <div class="content main-container">
    <div class="top clearfix">
      <div class="info">
        <p class="blod">说明：为加快介绍费的发放进度，我们安排每月结算两次:</p>
        <p>1）保单冷静期截止日在当月12日或之前，介绍费将于下月10日安排结算；</p>
        <p>2）保单冷静期截止日在当月12日之后，介绍费将于下月25日安排结算；</p>
        <p class="blod">
          备注： 因为香港部分银行转账有周期，到账延误两个工作日属于正常情况；若发放的日期是香港公众假期或休息日，介绍费发放将顺延至下一个工作日进行安排;
        </p>
        <p style="padding-top: 4px">举例：1.保单冷静期截止日为8月12日，则9月10日安排结算</p>
        <p class="p2">2.保单冷静期截止日为8月30日，则9月25日安排结算</p>
      </div>
    </div>
    <Tabs v-model="searchParams.status" :animated="false" @on-click="handleToggleTab">
      <TabPane v-for="tab in tabsList" :key="tab.value" :label="getNumText(tab.label, tab.value)" :name="tab.value"></TabPane>
    </Tabs>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">结算日期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
        />
      </div>
      <div class="btn-item">
        <Button type="primary" class="ico-btn" @click="searchAjax()">查询</Button>
        <Button type="primary" ghost @click="handleReset">重置</Button>
      </div>
    </div>
    <div class="table-box setTable">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span @click="handleViewItem(row)" class="table-btn">明细</span>
          <span v-if="[3, '3'].includes(row.status)" @click="handleConfirm(row)" class="table-btn">确认</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        :page-size-opts="[10, 20, 30, 50, 100]"
        style="text-align: center"
      />
    </div>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import { pageTool, common } from '@/api/mixins';
const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
export default {
  mixins: [pageTool, common],
  components: {
    lzDicTxt
  },
  computed: {
    columns() {
      let columns = [];
      columns.push(
        {
          title: '结算日期',
          align: 'center',
          key: 'settlementDate',
          minWidth: 120,
          render(h, params) {
            const value = params.row.settlementDate ? params.row.settlementDate.substr(0, 10) : '';
            return <div>{value}</div>;
          }
        },
        {
          title: '转介人',
          key: 'tenantName',
          align: 'center',
          width: 140
        }
      )
      if (this.userInfo.merchantType == 3) {
        columns.push(

          {
            title: '转介人级别',
            key: 'level',
            align: 'center',
            width: 140,
            render(h, params) {
              let level = params.row.level;
              return <span>{chineseNumbers[level]}级</span>;
            }
          }
        )
      }
      columns.push(
        {
          title: '保单量',
          align: 'center',
          key: 'policyNum',
          minWidth: 100
        },
        {
          title: '规模保费（港币）',
          align: 'center',
          key: 'fee',
          minWidth: 160
        },
        {
          title: '保单积分',
          key: 'ledgerDownSum',
          align: 'center',
          minWidth: 120
        },
        {
          title: '周边收支',
          key: 'extsvcItemSum',
          align: 'center',
          minWidth: 120
        },
        {
          title: '财务增减',
          key: 'financeItemSum',
          align: 'center',
          minWidth: 120
        },
        {
          title: '积分总额',
          key: 'amount',
          align: 'center',
          minWidth: 120
        },
        {
          title: '打款时间',
          key: 'payDate',
          align: 'center',
          minWidth: 160
        },
        // {
        //   title: '结算积分',
        //   align: 'center',
        //   key: 'amount',
        //   minWidth: 100
        // },
        // {
        //   title: '状态',
        //   align: 'center',
        //   key: 'withdrawStatus',
        //   minWidth: 100,
        //   render: (h, params) => {
        //     return <lzDicTxt dicCode={params.row.status} dicType="SETTLEMENT_DOWN_STATUS" />;
        //   }
        // },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          width: 120,
          fixed: 'right'
        }
      )
      return columns
    }
  },
  data() {
    return {
      userInfo: {},
      searchParams: {
        status: '5',
        settlementDate: ''
      },
      selectArr: [], //表格选择的数据
      tabsList: [
        {
          label: '打款成功',
          value: '5',
        }
      ]
    };
  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let statusList = this.$units.dicObj2DicArr('SETTLEMENT_DOWN_STATUS');
    statusList = statusList.filter(item => !['1', '2'].includes(item.value));
    this.statusList = JSON.parse(JSON.stringify(statusList));
    this.initListParams('/buz/settlementDown/read/list');
  },
  activated() {
    this.getList();
  },
  methods: {
    getNumText(label, value) {
      return label;
    },
    handleToggleTab(tabName) {
      this.searchAjax();
    },
    reload() {
      this.selectArr = [];
      this.isAll = false;
      this.getList();
    },
    handleReset() {
      this.pageNum = 1;
      this.searchParams.tenantId = '';
      this.searchParams.settlementDate = '';
      this.getList();
    },
    handleViewItem(row) {
      this.openPageTabTags('/operate/ledgerManage/confirmPoints/detail', {
        id: row.id || '',
        mode: [3, '3'].includes(row.status) ? 'edit' : 'read',
        backUrl: this.$route.fullPath,
        time: Date.now()
      });
    },
    handleConfirm(row) {
      this.$notice.inquiry('确认结算？').then(() => {
        this.$http({
          url: '/buz/settlementDown/updateStatus',
          type: 'POST',
          data: {
            id: row.id,
            status: 4
          }
        })
          .then(res => {
            if (res.httpCode != 1) {
              this.$notice.error('操作失败');
              return;
            }
            this.$notice.success('操作成功');
            this.getList();
          })
          .catch(err => {
            console.error(err);
            this.$notice.error('操作失败');
          });
      });
    },
    // 设置参数
    setListParams(params) {
      // 结算日期
      this.$units.formatDateRange(params, 'settlementDate', ['settlementDateStart', 'settlementDateEnd'], true);
      params.status = params.status === '*' ? '' : params.status;
    },
    // 重置查询
    resetSearch() {
      this.selectArr = [];
      this.isAll = false;
      this.searchParams = JSON.parse(JSON.stringify(this.searchParamsOrigin));
      this.searchAjax();
    }
  }
};
</script>
<style lang="scss" scoped>
.info {
  color: #6e574a;
  line-height: 1.6;
  border-radius: 4px;
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 12px 24px;
  font-size: 13px;
  .p2 {
    padding-left: 3em;
  }
  .blod {
    font-weight: bold;
  }
}
.content {
  .top {
    padding-bottom: 15px;
  }
}
/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #ccc;
  color: #ccc;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
</style>
